import script from "./SubmitPortfolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubmitPortfolio.vue?vue&type=script&setup=true&lang=ts"

import "./SubmitPortfolio.vue?vue&type=style&index=0&id=c92a461e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c92a461e"]])

export default __exports__